/* eslint-disable import/no-anonymous-default-export */
import { PreviewClass } from '../models';
import {  makeCrudObject} from './api';

const endpoint = 'preview-classes';

export default {
    ...makeCrudObject<PreviewClass>(endpoint),
};
